export default __webpack_public_path__ + "static/media/cartao_gold.64f66dd1.png";